module.exports = __webpack_public_path__ + "static/fipcwhiteelephant1-da388fae90a4c20e1e2be07c33572f7c.jpeg";